import { render, staticRenderFns } from "./CmgRestaurantAddressItem.vue?vue&type=template&id=2070b70d&scoped=true&lang=pug&"
import script from "./cmg-restaurant-address-item.ts?vue&type=script&lang=ts&"
export * from "./cmg-restaurant-address-item.ts?vue&type=script&lang=ts&"
import style0 from "./CmgRestaurantAddressItem.vue?vue&type=style&index=0&id=2070b70d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2070b70d",
  null
  
)

export default component.exports